import { abilityVoiceEvents } from '../../content/voices/voice-events.js';
import type { ClientMessage, WorldSnapshot } from '../../shared/network/protocol.js';

/**
 * The voice event a command the player sends calls for, and the heroes who may answer it; null for commands that make no sound.
 * Shared by the game and the scenario viewer, so an order sounds the same wherever it comes from. Selection and refusals are not
 * commands and are triggered by the interface.
 */
export function voiceForCommand(message: ClientMessage, snapshot: WorldSnapshot | null): { heroIds: string[]; event: string } | null {
  switch (message.type) {
    case 'move': return { heroIds: message.heroIds, event: snapshot?.inCombat ? 'combat-move' : 'move' };
    case 'attack': {
      // A hero already fighting someone else turns on the new foe; the rest are simply sent in.
      const switching = message.heroIds.filter(id => { const current = snapshot?.heroes.find(hero => hero.id === id)?.combat.targetId; return current && current !== message.targetId; });
      return switching.length ? { heroIds: switching, event: 'change-target' } : { heroIds: message.heroIds, event: 'attack' };
    }
    case 'stop': return { heroIds: message.heroIds, event: 'stop' };
    case 'ability': { const event = abilityVoiceEvents[message.abilityId]; return event ? { heroIds: [message.heroId], event } : null; }
    case 'use-item': return { heroIds: [message.heroId], event: 'potion' };
    case 'loot': return { heroIds: [message.heroId], event: 'loot' };
    case 'open-container': return { heroIds: [message.heroId], event: 'interact' };
    default: return null;
  }
}
